import { useContext } from "react";
import { DocumentStorageContext } from "../contexts/DocumentStorageContext";

/**
 * Custom hook for accessing the saved-document list from DocumentStorageContext.
 *
 * Must be used within a {@link DocumentStorageProvider}.
 *
 * @throws Error if used outside of DocumentStorageProvider
 *
 * @example
 * const { documents, count, loading, refresh } = useDocumentStorage();
 */
export const useDocumentStorage = () => {
  const context = useContext(DocumentStorageContext);

  if (context === undefined) {
    throw new Error(
      "useDocumentStorage must be used within a DocumentStorageProvider"
    );
  }

  return context;
};
